import {func, node} from 'prop-types';
import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';

function Form({onSubmit, children}) {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
}

Form.propTypes = {
  onSubmit: func.isRequired,
  children: node.isRequired,
};

export default Form;
